var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * DownloadBox component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconDownloadBox extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.7495 12.7805C12.7495 12.3662 12.4137 12.0305 11.9995 12.0305C11.5853 12.0305 11.2495 12.3662 11.2495 12.7805V20.3345L8.62799 17.713C8.33509 17.4201 7.86022 17.4201 7.56733 17.713C7.27443 18.0059 7.27443 18.4808 7.56733 18.7737L11.4692 22.6756C11.7621 22.9685 12.237 22.9685 12.5299 22.6756L16.4318 18.7737C16.7247 18.4808 16.7247 18.0059 16.4318 17.713C16.1389 17.4201 15.6641 17.4201 15.3712 17.713L12.7495 20.3347V12.7805Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.61484 1.10516L6.59517 1.10542C6.1998 1.11579 5.8137 1.22747 5.47385 1.42977C5.13871 1.62926 4.85959 1.91028 4.66241 2.24657L1.22458 7.69109C1.14983 7.80647 1.10593 7.94368 1.10453 8.09105C1.10451 8.09249 1.1045 8.09392 1.1045 8.09535C1.10449 8.09634 1.10449 8.09733 1.10449 8.09833V20.5845C1.10449 21.1973 1.34795 21.7851 1.7813 22.2184C2.21465 22.6518 2.80241 22.8952 3.41526 22.8952H4.97603C5.39024 22.8952 5.72603 22.5595 5.72603 22.1452C5.72603 21.731 5.39024 21.3952 4.97603 21.3952H3.41526C3.20023 21.3952 2.99401 21.3098 2.84196 21.1578C2.68991 21.0057 2.60449 20.7995 2.60449 20.5845V8.84833H21.3945V20.5845C21.3945 20.7995 21.3091 21.0057 21.157 21.1578C21.005 21.3098 20.7988 21.3952 20.5837 21.3952H19.023C18.6087 21.3952 18.273 21.731 18.273 22.1452C18.273 22.5595 18.6087 22.8952 19.023 22.8952H20.5837C21.1966 22.8952 21.7843 22.6518 22.2177 22.2184C22.651 21.7851 22.8945 21.1973 22.8945 20.5845V8.09928V8.09833C22.8945 7.94819 22.8504 7.80836 22.7744 7.69109L19.3366 2.24654C19.1394 1.91026 18.8603 1.62925 18.5251 1.42977C18.1853 1.22747 17.7992 1.11579 17.4038 1.10542L17.3841 1.10516H6.61484ZM6.24107 2.71871C6.35796 2.64913 6.49043 2.61011 6.62627 2.60516H17.3727C17.5086 2.61011 17.641 2.64913 17.7579 2.71871C17.8772 2.78969 17.9762 2.89008 18.0455 3.01029C18.0505 3.01895 18.0557 3.02752 18.061 3.03597L20.7839 7.34824H3.21506L5.93795 3.03597C5.94329 3.02752 5.94846 3.01895 5.95346 3.01029C6.0228 2.89008 6.12183 2.78969 6.24107 2.71871Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconDownloadBox.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconDownloadBox.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconDownloadBox.prototype, "size", void 0);
if (customElements.get('cat-icon-download-box') === undefined) {
    customElements.define('cat-icon-download-box', BlocksIconDownloadBox);
}
